import AcquisitionModal from "./AcquisitionModal";

const AcquisitionItem = (props) => {
  return (
    <div
      className="c-book-section"
      data-bs-toggle="modal"
      data-bs-target={`#acquisitionModal-${props?.item?.id}`}
      role="button"
    >
      <img
        type="button"
        src={props.item?.cover}
        className="figure-img img-fluid rounded border border-1 c-cover-thumb"
        alt={props.item.title}
      />
      <div className="c-book-data">
        <div className="c-book-title">{props.item.title}</div>
        {props.item?.author !== "null" && (
          <div className="c-book-author">{props.item.author}</div>
        )}
        {props.item?.file !== "null" && (
          <div className="c-book-file">
            <a
              className="c-button btn btn-outline-primary"
              href={props.item.file}
              target="_blank"
              rel="noreferrer"
              role="button"
            >
              Ver ebook
            </a>
          </div>
        )}
      </div>
      <AcquisitionModal
        modalID={`acquisitionModal-${props?.item?.id}`}
        item={props?.item}
      />
    </div>
  );
};

export default AcquisitionItem;
